import clsx from 'clsx'
import './spinner.scss'

const Spinner = ({ className }) => {
    return (
        <div className={clsx('avo__spinner', className)} />
    )
}

export default Spinner